document.addEventListener('DOMContentLoaded', () => {
	const stickySides = document.querySelectorAll('.sticky-side');

	stickySides.forEach((sticky) => {
		const targetId = sticky.getAttribute('data-sticky');
		const target = document.getElementById(targetId);
		if (!target) return;

		const stickyHeight = sticky.offsetHeight;
		const targetHeight = target.offsetHeight;
		const stickyOriginalWidth = sticky.offsetWidth + 'px';

		function handleScroll() {
			// Disable sticky below 768px
			if (window.innerWidth < 768) {
				sticky.style.position = '';
				sticky.style.top = '';
				sticky.style.bottom = '';
				sticky.style.width = '';
				return;
			}

			const scrollY = window.scrollY || window.pageYOffset;

			let navOffset = window.innerWidth > 768 ? 112 : 48;

			// Extra offset for admin-bar
			if (document.body.classList.contains('admin-bar')) {
				navOffset += window.innerWidth > 768 ? 32 : 46;
			}

			const targetTop = target.getBoundingClientRect().top + scrollY;

			if (scrollY + navOffset >= targetTop && scrollY + navOffset <= targetTop + targetHeight - stickyHeight) {
				sticky.style.position = 'fixed';
				sticky.style.top = navOffset + 'px';
				sticky.style.width = stickyOriginalWidth;
			} else if (scrollY + navOffset > targetTop + targetHeight - stickyHeight) {
				// Stay at bottom of target div
				sticky.style.position = 'absolute';
				sticky.style.top = 'auto';
				sticky.style.bottom = '0px';
				sticky.style.width = stickyOriginalWidth;
			} else {
				// Reset
				sticky.style.position = '';
				sticky.style.top = '';
				sticky.style.width = '';
			}
		}

		window.addEventListener('scroll', handleScroll);
		window.addEventListener('resize', handleScroll);
		handleScroll();
	});
});
